import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { calculateRem } from "@uie/javascript-style-helpers";
import { verizonTheme as colors } from "@vds/theme";
import { withVDSManager } from "@vds-core/utilities";
import IconData from "../utils/data.json";
var propTypes = {
  /**
   * @ignore
   */
  ariaLabel: PropTypes.string,
  /**
   * Size of the icon.
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.number]),
  /**
   * @deprecated color
   */
  lineColor: PropTypes.string,
  //DEPRECATED
  /**
   * Color of the icon.
   */
  color: PropTypes.string,
  /**
   * @deprecated
   */
  backgroundColor: PropTypes.string,
  /**
   * @deprecated
   */
  style: PropTypes.object,
  /**
   * The tabIndex of the icon.
   */
  tabIndex: PropTypes.number,
  /**
   * Boolean to determine if Icon is inverted.
   */
  inverted: PropTypes.bool,
  /**
   * @ignore
   * passes through icon data object
   */
  data: PropTypes.object,
  /**
   * @ignore
   * Boolean to determine if Icon is focused
   */
  focused: PropTypes.bool,
  /**
   * @ignore
   * Boolean to determine if Icon should receive focus state
   */
  focusState: PropTypes.bool,
  /**
   * @ignore
   * Boolean to determine if Icon should receive focus state
   */
  focusRadius: PropTypes.string,
  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string,
  /**
   * Hides content from assistive technology when set to true
   */
  ariaHidden: PropTypes.bool,
  /**
   * Determines whether the Icon is focusable in IE11, defaults to "false"
   */
  focusable: PropTypes.string,
  /**
   * Determines if the vectorEffect of the icon is none, or non-scaling-stroke.
   */
  vectorEffect: PropTypes.oneOf(["none", "non-scaling-stroke"]),
  /**
   *  @ignore Determines the stoke width of the icon path, if medium, stoke with is 2px, otherwise defaults to light of 1px.
   */
  weight: PropTypes.oneOf(["light", "medium"]),
  /**
   * Name of icon. Identifies which icon to render.
   */
  name: PropTypes.oneOf(["one-year-auxiliary", "one-year", "3d-ad", "cta", "ctr", "nfc-tag", "satellite", "tv-content", "url-transparency", "accessibility-auxiliary", "accessibility", "adaptive-speaker", "ad-tech-stack", "add-folder", "add-to-favorite-auxiliary", "add-to-favorite", "add-user", "added-to-favorite", "advanced-settings", "agriculture-leaves", "agriculture-tractor", "agriculture-vineyard", "air-conditioner", "airport", "alert-notification-auxiliary", "alert-notification", "american-sign-language-auxiliary", "american-sign-language", "analytics", "announcement", "ar", "archive", "artboard", "asset-tracking-auxiliary", "asset-tracking", "assisted-listening-system-auxiliary", "assistive-listening-systems", "at", "attach", "audience-targeted-search", "audio-description-auxiliary", "audio-description", "award", "awareness", "baby-monitor", "barcode", "battery-auxiliary", "battery", "best-practices", "bid-auxiliary", "bid", "bill-down-auxiliary", "bill-down", "bill-up-auxiliary", "bill-up", "blind-auxiliary", "blind", "bluetooth", "bonus-data-auxiliary", "bonus-data", "bookmark-auxiliary", "bookmark", "bot", "box-open", "braille-auxiliary", "braille", "brightness", "bring-your-own-device-auxiliary", "bring-your-own-device", "business-continuity-auxiliary", "business-continuity", "calendar-vds", "calendar", "calibrate", "called-id-auxiliary", "caller-id", "camera-auxiliary", "camera", "carryover-data-auxiliary", "carryover-data", "cell-tower", "chat", "checkmark-alt-auxiliary", "checkmark-alt-vds", "checkmark-alt", "checkmark-auxiliary", "checkmark-vds", "checkmark", "clean-surface", "clock-auxiliary", "clock", "close-alt-auxiliary", "close-alt", "close-auxiliary", "close-vds", "close", "closed-captioning-auxiliary", "closed-captioning", "cloud-alt", "cloud-document", "cloud", "coffee", "cognitive-disability-auxiliary", "cognitive-disability", "coin", "comparison", "compass-auxiliary", "compass", "compliance-document", "compose", "condition-based-maintenance-auxiliary", "condition-based-maintenance-wrench-auxiliary", "condition-based-wrench", "condition-based-maintenance", "connect-auxiliary", "connect-parts", "connect", "construction-auxiliary", "construction-hammer-auxiliary", "construction-hammer", "construction-truck", "consultative-transfer", "convergence", "conversion", "count-down", "credit-card", "creditcard-auxiliary", "crop", "cross-device-targeting", "cross-device", "custom-audience", "customize", "data-boost-auxiliary", "data-boost", "data", "deaf-auxiliary", "deaf", "decrease", "device-activity", "device-protection-auxiliary", "device-protection", "devices-addons-auxiliary", "devices-addons", "digital-content", "digital-signage-auxiliary", "digital-signage-car-auxiliary", "digital-signage-car", "digital-signage", "dining", "direct-carrier-billing", "directory", "display-utility", "display", "distribution", "domain-targeting", "doorbell", "down-arrow-auxiliary", "down-arrow-vds", "down-arrow", "down-caret-vds", "down-caret", "download", "drag-and-drop", "driver", "drone-camera-auxiliary", "drone-camera", "drop-shipment", "duplicate", "edit", "education-auxiliary", "education-curriculum-auxiliary", "education-curriculum", "education", "electric-power-auxiliary", "electric-power", "electric-utility-auxiliary", "electric-utility", "email", "embedded-sound", "emoji", "energy-science-auxiliary", "energy-science", "energy-utilities-auxiliary", "energy-utilities", "enterprise-auxiliary", "enterprise", "error-auxiliary", "error-vds", "error", "euro", "even-more-flexibility-auxiliary", "even-more-flexibility", "expense", "external-link", "face-covering", "facebook", "favorite", "fax", "federal-defense-auxiliary", "federal-defense", "feedback-auxiliary", "feedback", "filter-auxiliary", "filter-off-auxiliary", "filter-off", "filter", "financial-auxiliary", "financial", "find-my-remote-auxiliary", "find-my-remote", "fine-art", "fingerprint-sensor", "fire", "fit-to-zone", "flag", "fleet-auxiliary", "fleet-tracking-auxiliary", "fleet-tracking", "fleet", "flexibility-auxiliary", "flexibility-rectangles-auxiliary", "flexibility-rectangles", "flexibility", "flip-camera", "flurry", "forwarded-call", "fridge", "fullscreen", "gaming", "gas-auxiliary", "gas", "gateway-auxiliary", "gateway", "geofence", "gift-auxiliary", "gift", "gifted-data-auxiliary", "gifted-data", "government-auxiliary", "government", "grid-view", "group-auxiliary", "group-family", "growth-auxiliary", "growth-opportunities", "growth", "hackers-auxiliary", "hackers", "healthcare-corporate-auxiliary", "healthcare-corporate", "healthcare-general-auxiliary", "healthcare-general", "healthcare-worker-auxiliary", "healthcare-worker", "history", "home-internet-auxiliary", "home-internet", "home", "humidity", "ideas-solutions-auxiliary", "ideas-solutions", "identity-graph", "impression-video", "in-store-pickup-auxiliary", "in-store-pickup", "incoming-call", "increase", "industry-auxiliary", "industry", "inferred-identity", "info-vds", "info", "instagram", "insurance-auxiliary", "insurance", "intelligent-tracking-auxiliary", "intelligent-tracking", "international-long-distance", "international-symbol-of-access-suite-auxiliary", "international-symbol-of-access", "international", "internet-of-things-auxiliary", "internet-of-things", "inventory", "invitation-accepted", "invitation-expired", "invitation-rejected", "ironing-board", "irobot", "join-call-auxiliary", "join-call", "k12-education-auxiliary", "k12-education", "kids-stroller", "landscape", "laptop-antivirus-auxiliary", "laptop-antivirus", "laptop-controls-auxiliary", "laptop-controls", "laptop-gps-tracking-auxiliary", "laptop-gps-tracking", "laptop-settings-auxiliary", "laptop-settings", "laptop-trends-auxiliary", "laptop-trends", "laptop-wireless-auxiliary", "laptop-wireless", "large-plan-auxiliary", "large-plan", "law-auxiliary", "law", "left-arrow-auxiliary", "left-arrow-vds", "left-arrow", "left-caret-vds", "left-caret", "left-directional-arrow-auxiliary", "levers", "light", "link", "list-auxiliary", "list", "lmr-auxiliary", "lmr", "loader-auxiliary", "loader", "location", "lock-closed-auxiliary", "lock-closed", "lock-open-auxiliary", "lock-open", "logout-auxiliary", "logout", "loyalty-retention-auxiliary", "loyalty-retention", "manufacturing-auxiliary", "manufacturing", "map-view", "masonry-view", "maximize", "media-entertainment-auxiliary", "media-entertainment", "medium-business-auxiliary", "medium-business", "medium-plan-auxiliary", "medium-plan", "menu-auxiliary", "menu", "merge-calls", "microphone", "minus-large-auxiliary", "minus-vds", "minus", "missed-call", "mobile-apps-auxiliary", "mobile-apps", "mobile-command-center-auxiliary", "mobile-command-center", "mobile-hotspot-auxiliary", "mobile-hotspot", "mobile-kiosk-info-auxiliary", "mobile-kiosk-info", "mobile-kiosk-wireless-auxiliary", "mobile-kiosk-wireless", "mobile-plus-tv", "mobile-retail-auxiliary", "mobile-retail", "mobile-retargeting", "mobile-search-auxiliary", "mobile-search", "mobile-workforce-management-auxiliary", "mobile-workforce-management", "more-flexibility-auxiliary", "more-flexibility", "more-horizontal-auxiliary", "more-horizontal", "motion-detector", "move-to", "multicast", "multiple-device-protection-auxiliary", "multiple-device-protection", "multiple-devices-auxiliary", "multiple-devices", "multiple-documents", "music", "mute", "my-account-auxiliary", "my-account", "nation-wide-auxiliary", "nation-wide", "native-video", "native", "network-auxiliary", "network-connection", "network", "network-attached-storage", "news", "next", "night", "no-auxiliary", "no-fee-auxiliary", "no-fee", "no-off-auxiliary", "no-off", "no-smoking", "no-video", "no", "notification-auxiliary", "notification-off-auxiliary", "notification", "notifications-off", "notify-me-auxiliary", "notify-me", "office-phone-system-auxiliary", "office-phone-system", "oil-industry-auxiliary", "oil-industry", "on-demand", "on-go-car", "one-year", "open-captioning-auxiliary", "open-captioning", "operational-transformation-auxiliary", "operational-transformation", "orders-auxiliary", "orders", "out-of-stock-auxiliary", "out-to-stock", "outgoing-call", "pack-backpack", "pack-luggage", "pack-purse", "paper-free-billing", "passenger", "pause-internet", "pause", "peel-sticker", "pets-collar", "pharmaceutical-auxiliary", "pharmaceutical", "phone-all-good-auxiliary", "phone-all-good", "phone-alt-auxilliary", "phone-auxiliary", "phone-favorite-auxiliary", "phone-favorite", "phone-medical-auxiliary", "phone-medical", "phone-public-safety-auxiliary", "phone-public-safety", "phone-volume-auxiliary", "phone-volume", "phone", "phone-alt", "photo", "platform", "play-alt", "play-with", "play", "plus-large-auxiliary", "plus-vds", "plus", "police-fleet-auxiliary", "police-fleet", "portrait", "pressure", "previous", "print", "professional-services-case-auxiliary", "professional-services-case", "professional-services-chart-auxiliary", "professional-services-chart", "public-safety-auxiliary", "public-safety", "public-transportation-auxiliary", "public-transportation", "purchase-data-auxiliary", "purchase-data", "push-notification", "push-to-talk-auxiliary", "push-to-talk", "question", "real-time-tracking", "real-time", "recycle", "remind-me-auxiliary", "remind-me", "reminder", "remove-item", "reoccuring-payment", "reoccurring-payment-auxiliary", "replace-a-photo", "reply", "research", "reservation", "reservations-auxiliary", "retail-store", "retargeting", "returns-auxiliary", "returns", "rewards-auxiliary", "rewards", "right-arrow-auxiliary", "right-arrow-vds", "right-arrow", "right-caret-vds", "right-caret", "right-directional-arrow-auxiliary", "ringing", "ringtone", "risk-monitor", "router-auxiliary", "router", "rss", "satellite-off", "save", "scale-alt", "scale", "school-notebook", "search-auxiliary", "search", "security-alert-auxiliary", "security-alert", "security-check-auxiliary", "security-check", "security-keyhole-auxiliary", "security-keyhole", "security-wireless-auxiliary", "security-wireless", "send-message", "server-search-auxiliary", "server-search", "server-stack-auxiliary", "server-stack", "set-fallback-image", "set-gallery-image", "settings-auxiliary", "settings", "share", "shipping-auxiliary", "shipping", "shock", "shopping-auxiliary", "shopping-bag-auxiliary", "shopping-bag", "shopping", "signal-broadcast", "sim-card-auxiliary", "sim-card", "single-document", "small-business-auxiliary", "small-business", "small-plan-auxiliary", "small-plan", "smart-assistant", "smart-boiler", "smart-communities-auxiliary", "smart-communities", "smart-family-child-address-book", "smart-lighting-auxiliary", "smart-lighting", "smart-meter-auxiliary", "smart-meter", "smart-scooter", "smart-socket", "smart-switch", "smoke-detector", "snooze", "social-distancing", "solar-panel", "sound-auxiliary", "sound", "speaker-mute", "speaker-phone", "speed-monitoring-auxiliary", "speed-monitoring", "speed", "sports-bike", "sports-skis", "sports-soccer", "sports-tennis", "stadium-flag", "stakeholder", "star-auxiliary", "star-off", "star", "steps", "stocktogether", "stop-alt", "stop", "support-auxiliary", "support-drawer-auxiliary", "support-drawer", "support", "survey", "swipe-auxiliary", "swipe-left-auxiliary", "swipe-left", "swipe-right-auxiliary", "swipe-right", "swipe", "switch-auxiliary", "switch", "sync-auxiliary", "sync", "tablet-auxiliary", "tablet-data-auxiliary", "tablet-data", "tablet-wireless-auxiliary", "tablet-wireless", "tablet", "tag-auxiliary", "tag", "talking", "target-goal-auxiliary", "target-goal", "taxes-auxiliary", "taxes", "team-leader", "tech-laptop-auxiliary", "tech-laptop", "tech-phone", "tech-phones-auxiliary", "technology-auxiliary", "technology", "telematics-car-auxiliary", "telematics-car", "teletype-auxiliary", "teletype", "temperature", "template", "text-to-speech", "theme", "thermostat-tech", "thumbs-down", "thumbs-up", "ticket", "tiles", "tilt", "timer", "tools", "top-box-auxiliary", "top-box", "total-mobile-protection-auxiliary", "total-mobile-protection", "trading-deck", "traffic-light-auxiliary", "traffic-light", "traffic", "transportation-auxiliary", "transportation", "trash", "travel-keys", "travel-pass", "trip-planner", "trumpet", "turnon-off", "tv", "twitter", "unification", "unified-comms-auxiliary", "unified-comms", "unlimited-plan-auxiliary", "unlimited-plan", "up-arrow-auxiliary", "up-arrow-vds", "up-arrow", "up-caret-vds", "up-caret", "uplink-auxiliary", "uplink", "upload", "user-registration-auxiliary", "user-registration", "user-settings", "utility-grid-management-auxiliary", "utility-grid-management", "vibration", "video-on-tablet-auxiliary", "video-on-tablet", "video", "virtual-reality", "visibility", "voice-hd", "voice-mail", "volume", "warning-auxiliary", "warning", "water-resistant-auxiliary", "water-resistant", "water-utility-auxiliary", "water-utility", "wearable-auxiliary", "wearable", "weather", "webinar-auxiliary", "webinar", "weights", "white-black-list", "wifi", "wireless-vending-auxiliary", "wireless-vending", "wireless-video-surveillance-auxiliary", "wireless-video-surveillance", "yield", "youtube", "zoom-in", "zoom-out"])
};
var defaultProps = {
  size: "extraSmall",
  data: IconData,
  color: "black",
  backgroundColor: "transparent",
  style: undefined,
  lineColor: undefined,
  //DEPRECATED
  tabIndex: 0,
  inverted: false,
  // props created for 1.0
  weight: "light",
  focused: false,
  focusState: false,
  focusRadius: "50%",
  ariaHidden: false,
  focusable: "false",
  vectorEffect: "none"
};
var StyledSVG = /*#__PURE__*/styled.svg.withConfig({
  displayName: "StyledSVG",
  componentId: "sc-j170bv-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  display: inline-block;\n  height: ", ";\n  width: ", ";\n  min-height: ", ";\n  min-width: ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), function (props) {
  return props.backgroundColor;
}, function (_ref) {
  var iconHeight = _ref.iconHeight;
  return calculateRem(iconHeight);
}, function (_ref2) {
  var iconWidth = _ref2.iconWidth;
  return calculateRem(iconWidth);
}, function (_ref3) {
  var iconHeight = _ref3.iconHeight;
  return calculateRem(iconHeight);
}, function (_ref4) {
  var iconWidth = _ref4.iconWidth;
  return calculateRem(iconWidth);
}, function (_ref5) {
  var tabIndex = _ref5.tabIndex;
  return tabIndex < 0 && "\n    outline: none;\n    pointer-events: none;\n  ";
}, function (_ref6) {
  var focusState = _ref6.focusState,
    focused = _ref6.focused,
    inverted = _ref6.inverted,
    focusRadius = _ref6.focusRadius,
    borderOffset = _ref6.borderOffset;
  return focusState && focused && "\n      border: 1px dashed ".concat(inverted ? "white" : "black", ";\n      border-radius: ").concat(focusRadius, ";\n      padding: ").concat(borderOffset ? borderOffset : 0, ";\n  ");
}, function (_ref7) {
  var focusState = _ref7.focusState,
    focused = _ref7.focused,
    focusRadius = _ref7.focusRadius,
    borderOffset = _ref7.borderOffset;
  return focusState && !focused && "\n      border: 1px dashed transparent;\n      border-radius: ".concat(focusRadius, ";\n      padding: ").concat(borderOffset ? borderOffset : 0, ";\n  ");
});
var getStrokeWidth = function getStrokeWidth(hasStroke, weight) {
  if (!hasStroke) return "none";
  if (weight === "medium") {
    return 2;
  } else {
    return 1;
  }
};
var getIconSize = function getIconSize(size) {
  if (typeof size === "number") return calculateRem(size);
  switch (size) {
    case "extraLarge":
      return 28;
    case "large":
      return 24;
    case "medium":
      return 20;
    case "small":
      return 16;
    case "extraSmall":
    default:
      return 12;
  }
};
function mapChildren(children, iconColor, hasStroke, weight) {
  return children.length > 0 && children.map(function (child, index) {
    var attr = child.attributes;
    if (child.name === "g") {
      return /*#__PURE__*/React.createElement("g", {
        key: "".concat(child.name).concat(index)
      }, child.children.length > 0 && mapChildren(child.children));
    }
    if (child.name === "path") {
      var fill;
      if (attr.style) {
        fill = attr.style.split("fill:")[1];
      }
      return /*#__PURE__*/React.createElement("path", _extends({
        key: "".concat(child.name).concat(index),
        d: attr.d
      }, attr["vector-effect"] ? {
        vectorEffect: "non-scaling-stroke",
        stroke: attr.fill ? attr.fill : iconColor,
        strokeWidth: getStrokeWidth(hasStroke, weight),
        fill: "none"
      } : {
        stroke: "none",
        fill: !!fill ? fill : attr.fill ? attr.fill : iconColor
      }), child.children.length > 0 && mapChildren(child.children));
    }
    if (child.name === "circle") {
      return /*#__PURE__*/React.createElement("circle", _extends({
        id: attr.id,
        key: "".concat(child.name).concat(index),
        cx: attr.cx,
        cy: attr.cy,
        r: attr.r,
        opacity: attr.opacity
      }, attr["vector-effect"] ? {
        vectorEffect: "non-scaling-stroke",
        stroke: attr.fill ? attr.fill : iconColor,
        strokeWidth: getStrokeWidth(hasStroke, weight),
        fill: "none"
      } : {
        stroke: "none",
        fill: attr.fill ? attr.fill : iconColor
      }), child.children.length > 0 && mapChildren(child.children));
    }
    if (child.name === "rect") {
      return /*#__PURE__*/React.createElement("rect", _extends({
        key: "".concat(child.name).concat(index),
        x: attr.x,
        y: attr.y,
        ry: attr.ry,
        rx: attr.rx,
        transform: attr.transform,
        width: attr.width,
        height: attr.height
      }, attr["vector-effect"] ? {
        vectorEffect: "non-scaling-stroke",
        stroke: attr.fill ? attr.fill : iconColor,
        strokeWidth: getStrokeWidth(hasStroke, weight),
        fill: "none"
      } : {
        stroke: "none",
        fill: attr.fill ? attr.fill : iconColor
      }), child.children.length > 0 && mapChildren(child.children));
    }
    if (child.name === "polyline") {
      return /*#__PURE__*/React.createElement("polyline", _extends({
        key: "".concat(child.name).concat(index),
        points: attr.points
      }, attr["vector-effect"] ? {
        vectorEffect: "non-scaling-stroke",
        stroke: attr.fill ? attr.fill : iconColor,
        strokeWidth: getStrokeWidth(hasStroke, weight),
        fill: "none"
      } : {
        stroke: "none",
        fill: attr.fill ? attr.fill : iconColor
      }), child.children.length > 0 && mapChildren(child.children));
    }
    if (child.name === "line") {
      return /*#__PURE__*/React.createElement("line", _extends({
        key: "".concat(child.name).concat(index),
        x1: attr.x1,
        x2: attr.x2,
        y1: attr.y1,
        y2: attr.y2
      }, attr["vector-effect"] ? {
        vectorEffect: "non-scaling-stroke",
        stroke: attr.fill ? attr.fill : iconColor,
        strokeWidth: getStrokeWidth(hasStroke, weight),
        fill: "none"
      } : {
        stroke: "none",
        fill: attr.fill ? attr.fill : iconColor
      }), child.children.length > 0 && mapChildren(child.children));
    }
    if (child.name === "polygon") {
      return /*#__PURE__*/React.createElement("polygon", _extends({
        key: "".concat(child.name).concat(index),
        points: attr.points
      }, attr["vector-effect"] ? {
        vectorEffect: "non-scaling-stroke",
        stroke: attr.fill ? attr.fill : iconColor,
        strokeWidth: getStrokeWidth(hasStroke, weight),
        fill: "none"
      } : {
        stroke: "none",
        fill: attr.fill ? attr.fill : iconColor
      }), child.children.length > 0 && mapChildren(child.children));
    }
    if (child.name === "linearGradient") {
      return /*#__PURE__*/React.createElement("linearGradient", {
        key: "".concat(child.name).concat(index),
        id: attr.id,
        gradientUnits: attr.gradientUnits,
        x1: attr.x1,
        y1: attr.y1,
        x2: attr.x2,
        y2: attr.y2,
        gradientTransform: attr.gradientTransform
      }, child.children.length > 0 && mapChildren(child.children));
    }
    if (child.name === "stop") {
      return /*#__PURE__*/React.createElement("stop", {
        offset: attr.offset,
        stopColor: attr["stop-color"],
        key: "".concat(child.name).concat(index)
      }, child.children.length > 0 && mapChildren(child.children));
    }
  });
}
var Icon = function Icon(props) {
  var ariaHidden = props.ariaHidden,
    name = props.name,
    size = props.size,
    lineColor = props.lineColor,
    color = props.color,
    backgroundColor = props.backgroundColor,
    inverted = props.inverted,
    data = props.data,
    hasStroke = props.hasStroke,
    weight = props.weight,
    focused = props.focused,
    focusState = props.focusState,
    focusRadius = props.focusRadius,
    borderOffset = props.borderOffset,
    id = props.id,
    focusable = props.focusable,
    vectorEffect = props.vectorEffect;
  var iconMap = {
    "checkmark-alt": "checkmark-alt-vds",
    checkmark: "checkmark-vds",
    "right-arrow": "right-arrow-vds",
    "left-arrow": "left-arrow-vds",
    "up-arrow": "up-arrow-vds",
    "down-arrow": "down-arrow-vds",
    "right-caret": "right-caret-vds",
    "left-caret": "left-caret-vds",
    "up-caret": "up-caret-vds",
    "down-caret": "down-caret-vds",
    minus: "minus-vds",
    alert: "alert-vds",
    plus: "plus-vds",
    calendar: "calendar-vds",
    error: "error-vds",
    info: "info-vds",
    close: "close-vds",
    warning: "warning-vds"
  };
  var calculateIcon = function calculateIcon() {
    var originalIcons = Object.keys(iconMap);
    if (originalIcons.includes(name) && vectorEffect === "non-scaling-stroke") {
      var newName = iconMap[name];
      return data[newName];
    }
    return data[name];
  };
  var icon = calculateIcon();
  var iconColor = lineColor || color;

  //If inverted and no color specified
  if (inverted && !color && !lineColor) {
    iconColor = colors.white;
    //If inverted and color black
  } else if (inverted && (color === "black" || color === colors.black || color === "Black")) {
    iconColor = colors.white;
  }
  if (!icon) return null;
  return /*#__PURE__*/React.createElement(StyledSVG, {
    id: id,
    data: data,
    hasStroke: hasStroke,
    weight: weight,
    "aria-label": props.ariaLabel ? props.ariaLabel : name + " icon",
    "aria-hidden": ariaHidden,
    tabIndex: props.tabIndex,
    "alt-text": props.ariaLabel ? props.ariaLabel : name + "icon"
    //Passing rem values through to styled component keeps firefox and safari happy
    ,

    iconWidth: getIconSize(size),
    iconHeight: getIconSize(size),
    viewBox: icon.attributes.viewBox,
    backgroundColor: backgroundColor || "transparent",
    style: props.style,
    focused: focused,
    focusState: focusState,
    inverted: inverted,
    focusRadius: focusRadius,
    borderOffset: borderOffset,
    focusable: focusable
  }, mapChildren(icon.children, iconColor, hasStroke, weight));
};
Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;
export default withVDSManager(Icon);